module.exports = "<toaster-container></toaster-container>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main